import { AuthServiceModule } from 'services/auth/auth.service';
import { AppSettingsModule } from 'services/settings.provider';
import { StorageServiceModule } from 'services/storage/storage.service';
import { AuthTokenServiceModule } from 'services/auth/authToken.service';
import { Auth0AuthServiceModule } from 'services/auth/auth0auth.service';
import { SegmentServiceModule } from 'services/tracking/segment/segment.service';

import { DataServiceModule } from './data.service';

export const MyAccountServiceModule = angular
    .module('app.services.data.myAccount', [
        DataServiceModule,
        AppSettingsModule,
        StorageServiceModule,
        AuthTokenServiceModule,
        Auth0AuthServiceModule,
        AuthServiceModule,
        SegmentServiceModule
    ]).service('myAccountService', (
        $q,
        $window,
        $http,
        dataService,
        settings,
        authTokenService,
        auth0AuthService,
    ) => {
        let storeAdmin = null;

        return {
            getUser,
            getUserId,
            save,
            updatePassword,
            cancelAccount,
            getEmailVerifiedStatus,
            resendVerification,
            checkInterval: null
        };

        function getUser(force) {
            if (storeAdmin && !force) {
                $q.resolve(storeAdmin);
            }

            return auth0AuthService.getTokenSilently().then(getUserId).then((userId) => {
                const storeAdminUrl = `${settings.api.storeAdmin}/${userId}`;

                return dataService.get(storeAdminUrl).then((response) => {
                    storeAdmin = response;
                    return response;
                });
            });
        }

        function getUserId() {
            return auth0AuthService.getUser().then((auth0User) => {
                return auth0User ? auth0User.sub : null;
            });
        }

        function save(newUser) {
            return dataService.save(settings.api.storeAdmin, encodeURIComponent(newUser.id), newUser);
        }

        function updatePassword(user, pass) {
            return dataService.save(`${settings.api.storeAdmin}/${encodeURIComponent(user.id)}/password`, null, {
                email: user.email,
                oldPassword: pass.old,
                tenantId: authTokenService.getTenantId(),
                password: pass.new
            });
        }

        function cancelAccount() {
            return $http.delete(`${process.env.BASE_API_URL}/registration/stores`).then(() => {
                auth0AuthService.logout();
            });
        }

        function getEmailVerifiedStatus() {
            return getUser(true).then((user) => {
                return user.emailVerified;
            });
        }

        function resendVerification(user) {
            var payload = {
                email: user.email
            };
            return dataService.create(settings.api.verification, payload);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/myAccount.service.js